/* =========================================================
   OVERTOP — Cart Drawer UI v4.6.0
   Passive event-driven drawer cosmetics.
   No row reordering. No section repair loop. No mutation loop.
   ========================================================= */

(function () {
  'use strict';

  var VERSION = '4.6.0';

  var applying = false;
  var scheduled = false;
  var lastKnownItemCount = null;
  var emptyCloseIntentUntil = 0;
  var lastEmptyCloseAt = 0;
  var lastEventCart = null;

  window.__OT_DRAWER_UI_VERSION = VERSION;

  function findDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function findDialog(drawer) {
    return drawer && drawer.querySelector('dialog');
  }

  function findItemsTable(drawer) {
    return drawer && drawer.querySelector('.cart-items__table');
  }

  function findSummary(drawer) {
    return drawer && drawer.querySelector('.cart-drawer__summary');
  }

  function isMutating() {
    return !!window.__OT_ATOMIC_ADD_IN_PROGRESS;
  }

  function cartFromEvent(e) {
    var detail = e && e.detail;
    if (!detail) return null;

    return detail.cart || detail.resource ||
      (detail.data && (detail.data.cart || detail.data.resource)) || null;
  }

  function rememberCart(cart) {
    if (cart && cart.items && typeof cart.item_count !== 'undefined') {
      lastEventCart = cart;
      lastKnownItemCount = Number(cart.item_count || 0);
    }
  }

  function markEmptyCloseIntent(ms) {
    emptyCloseIntentUntil = Date.now() + (ms || 2200);
  }

  function route(path) {
    var root = '/';

    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        root = window.Shopify.routes.root || '/';
      }
    } catch (e) {}

    root = String(root).replace(/\/$/, '');
    return root + path;
  }

  function withTimeout(promise, ms, fallback) {
    return new Promise(function (resolve) {
      var done = false;

      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        resolve(fallback);
      }, ms || 1800);

      Promise.resolve(promise).then(function (value) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(value);
      }).catch(function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(fallback);
      });
    });
  }

  async function fetchCart() {
    var res = await fetch(route('/cart.js') + '?ot_drawer=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });

    return res.json();
  }

  // The "TOTAL ITEMS / Everything in your cart" pill was removed by request.
  // Keep this as a cleanup so any previously-rendered pill is stripped out.
  function ensureTotalItemsPill(drawer) {
    var pill = drawer && drawer.querySelector('#otTotalItemsPill');
    if (pill) pill.remove();
  }

  function closeDrawerOnceIfEmpty(drawer, cart) {
    if (!drawer || !cart || window.__OT_CHECKOUT_IN_PROGRESS) return;

    var count = Number(cart.item_count || 0);
    var wasNonEmpty = Number(lastKnownItemCount || 0) > 0;
    var now = Date.now();

    if (count > 0) {
      lastKnownItemCount = count;
      return;
    }

    var shouldClose = wasNonEmpty || now < emptyCloseIntentUntil;
    lastKnownItemCount = 0;

    if (!shouldClose) return;

    var dialog = findDialog(drawer);
    if (!dialog || !dialog.open) return;

    if (now - lastEmptyCloseAt < 1200) return;

    lastEmptyCloseAt = now;

    requestAnimationFrame(function () {
      try {
        if (typeof drawer.closeDialog === 'function') {
          drawer.closeDialog();
        } else if (typeof dialog.close === 'function') {
          dialog.close();
        }
      } catch (e) {}
    });
  }

  async function applyAll() {
    if (applying) return;
    if (isMutating()) {
      scheduleApply(260);
      return;
    }

    applying = true;

    try {
      var drawer = findDrawer();
      if (!drawer) return;

      var cart = lastEventCart;

      if (!cart || !cart.items || typeof cart.item_count === 'undefined') {
        cart = await fetchCart();
        rememberCart(cart);
      }

      ensureTotalItemsPill(drawer, cart.item_count || 0);
      closeDrawerOnceIfEmpty(drawer, cart);
    } finally {
      applying = false;
    }
  }

  function scheduleApply(delay) {
    if (scheduled) return;

    scheduled = true;

    setTimeout(function () {
      scheduled = false;
      applyAll();
    }, delay == null ? 160 : delay);
  }

  function boot() {
    scheduleApply(250);

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer-component')) {
        markEmptyCloseIntent(2200);
      }
    }, true);

    document.addEventListener('cart:update', function (e) {
      rememberCart(cartFromEvent(e));
      markEmptyCloseIntent(2200);
      scheduleApply(120);
      setTimeout(function () { scheduleApply(420); }, 420);
    });

    document.addEventListener('quantity-selector:update', function () {
      markEmptyCloseIntent(2200);
      scheduleApply(360);
    });

    document.addEventListener('ot:cart-qty-guard:normalized', function (e) {
      rememberCart(cartFromEvent(e));
      markEmptyCloseIntent(2200);
      scheduleApply(140);
    });

    document.addEventListener('ot:cart-qty-guard:add-sections', function () {
      markEmptyCloseIntent(2200);
      scheduleApply(260);
    });

    document.addEventListener('dialog:open', function () {
      scheduleApply(220);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
